import { render, staticRenderFns } from "./VideoGridlayout.vue?vue&type=template&id=156cb993&scoped=true"
import script from "./VideoGridlayout.vue?vue&type=script&lang=js"
export * from "./VideoGridlayout.vue?vue&type=script&lang=js"
import style0 from "./VideoGridlayout.vue?vue&type=style&index=0&id=156cb993&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cb993",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156cb993')) {
      api.createRecord('156cb993', component.options)
    } else {
      api.reload('156cb993', component.options)
    }
    module.hot.accept("./VideoGridlayout.vue?vue&type=template&id=156cb993&scoped=true", function () {
      api.rerender('156cb993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/VideoGridlayout.vue"
export default component.exports